import { render, staticRenderFns } from "./MacronutrientsSettings.vue?vue&type=template&id=3c6a7056&"
import script from "./MacronutrientsSettings.vue?vue&type=script&lang=js&"
export * from "./MacronutrientsSettings.vue?vue&type=script&lang=js&"
import style0 from "./MacronutrientsSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports